import { ChangeDetectionStrategy, Component, inject, linkedSignal } from '@angular/core';
import { AppUpgrade } from '@core/services/app-upgrade';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'm4w-upgrade-dialog',
  imports: [ButtonModule, Dialog],
  templateUrl: './upgrade-dialog.html',
  styleUrl: './upgrade-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeDialog {
  private readonly appUpgrade = inject(AppUpgrade);

  // Mirrors `updateAvailable`, but stays writable so "Later" can dismiss it without the source signal forcing it back open.
  public readonly visible = linkedSignal(() => this.appUpgrade.updateAvailable());

  public confirm(): void {
    this.appUpgrade.update();
  }

  public close(): void {
    this.visible.set(false);
  }
}
